import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  icons: {
    color: theme.palette.primary.red,
    fontSize: '26px',
  },
  iconsDisabled: {
    color: 'grey',
    fontSize: '26px',
  },
  modalContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  modal: {
    maxHeight: '90%',
    maxWidth: '890px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  uploadModal: {
    // maxWidth: '890px',
  },

  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
  },
  modalTitleAndIcon: {
    display: 'flex',
  },
  labelItem: {
    width: '100%',
  },
  modalTextfieldsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  uploadModalMainContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  modalButtonsContainer: {
    marginTop: '25px',
    display: 'flex',
    justifyContent: 'end',
  },
  switchAndTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  institutionAdminCreationField: {
    margin: '15px 0px',
    padding: '0px 10px',
  },
}));

export default useStyles;
